module.exports = __webpack_public_path__ + "static/media/residential-roofing-minneapolis.9691c9d3.jpg";